import { Vector2 } from 'three';

const globalUniforms = {
	uTime: { value: 0.0 },
	uDarkMode: { value: 0.0 },
	uMouse: { value: new Vector2() },
	uMotion: { value: new Vector2() },
};

const viewportUniforms = {
	uRatio: { value: 1 },
	uResolution: { value: new Vector2() },
	uMobile: { value: false },
};

export { globalUniforms, viewportUniforms };
